module.exports = __webpack_public_path__ + "img/ipswich-town-logo-icon.e27d379e.png";